import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { map, Observable, startWith, tap } from 'rxjs';

import { Ga4AnalyticsService } from '../../../core/analytics/ga4-analytics.service';
import { OgDataService } from '../../../core/seo/og-data.service';
import { NumeronCollectionModel } from '../models/numeron.model';
import { NumeronCardComponent } from '../../../shared/ui/numeron-card/numeron-card.component';

interface NumeronPageViewModel {
  numeronCollection: NumeronCollectionModel | null;
  isLoading: boolean;
  hasError: boolean;
}

@Component({
  selector: 'app-numeron-page',
  imports: [AsyncPipe, NumeronCardComponent],
  templateUrl: './numeron-page.component.html',
})
export class NumeronPageComponent {
  private readonly route = inject(ActivatedRoute);
  private readonly ga4AnalyticsService = inject(Ga4AnalyticsService);
  private readonly ogDataService = inject(OgDataService);

  protected readonly vm$: Observable<NumeronPageViewModel> = this.route.data.pipe(
    map((data) => (data['numeronCollection'] as NumeronCollectionModel | null) ?? null),
    tap((numeronCollection) => this.setOgData(numeronCollection)),
    map((numeronCollection) => ({
      numeronCollection,
      isLoading: false,
      hasError: numeronCollection === null,
    })),
    startWith({
      numeronCollection: null,
      isLoading: true,
      hasError: false,
    }),
  );

  private setOgData(numeronCollection: NumeronCollectionModel | null): void {
    if (!numeronCollection) {
      return;
    }

    const firstNumeron = numeronCollection.numerons[0];
    const firstNumeronTitle = numeronCollection.numerons[0]?.title?.trim();
    const ogTitle = firstNumeronTitle || numeronCollection.ogdata?.title || numeronCollection.title;
    const ogUrl = `https://numerical.co.in/numerons/numeron/${numeronCollection._id}`;
    const contentGroup = firstNumeron?.topic?.topic?.trim();

    numeronCollection.ogdata = {
      title: ogTitle,
      url: ogUrl,
    };

    this.ogDataService.setOgData(ogTitle, ogUrl);
    this.ga4AnalyticsService.trackPageView({
      contentGroup,
      contentId: firstNumeron?._id,
      contentType: 'Numeron',
    });
  }
}
